"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMyNotificationPreferences = exports.requestAirQualityService = exports.clearHumidityAlert = exports.requestHumidityService = exports.clearWaterLeakAlert = exports.requestWaterLeakService = exports.clearPowerMonitorAlert = exports.requestPowerMonitorService = exports.orderFilter = exports.clearHvacFilterAlert = exports.requestFilterService = exports.updateServiceCompany = exports.createServiceCompany = exports.deleteCustomer = exports.updateCustomer = exports.createCustomer = exports.updateServiceRequest = exports.createServiceRequest = exports.updateSensorAlertAcknowledgedStateAnonymous = exports.updateSensorAlertAcknowledgedState = exports.updateSensorAlertStatus = exports.createSensorEvent = exports.completeSensorInstall = exports.beginSensorInclusion = exports.identifySensor = exports.retrySensorInclusion = exports.retrySensorRemoval = exports.deleteSensor = exports.deleteSensorLink = exports.updateSensorBranchCircuits = exports.updateHubEnergyRate = exports.updateSensor = exports.createSensorGroup = exports.createSensorLink = exports.createSensor = exports.unlinkGateway = exports.linkGateway = exports.dissociateHubCustomer = exports.associateHubCustomer = exports.associateHub = exports.deleteHub = exports.updateHubConfig = exports.updateHubAddress = exports.updateHub = exports.createHub = exports.updateCustomerBacklightPreferences = void 0;
exports.updateCustomerBacklightPreferences = `
  mutation UpdateCustomerBacklightPreferences(
    $customerId: ID!
    $preferences: BacklightPreferencesInput!
  ) {
    updateCustomerBacklightPreferences(customerId: $customerId, preferences: $preferences) {
      id
      name
      email
      backlightPreferences {
        color {
          r
          g
          b
        }
        pattern
      }
    }
  }
`;
exports.createHub = `
  mutation CreateHub($input: CreateHubInput!) {
    createHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.updateHub = `
  mutation UpdateHub($input: UpdateHubInput!) {
    updateHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.updateHubAddress = `
  mutation UpdateHubAddress($input: UpdateHubAddressInput!) {
    updateHubAddress(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      street
      city
      state
      zip
      date
      time
      timezone
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.updateHubConfig = `
  mutation UpdateHubConfig($id: ID!, $config: String!) {
    updateHubConfig(id: $id, config: $config) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.deleteHub = `
  mutation DeleteHub($id: ID!) {
    deleteHub(id: $id) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.associateHub = `
  mutation AssociateHub($hubId: ID!, $hubName: String) {
    associateHub(hubId: $hubId, hubName: $hubName)
  }
`;
exports.associateHubCustomer = `
  mutation AssociateHubCustomer($hubId: ID!, $userId: ID!, $customerId: ID!) {
    associateHubCustomer(hubId: $hubId, userId: $userId, customerId: $customerId)
  }
`;
exports.dissociateHubCustomer = `
  mutation DissociateHubCustomer($hubId: ID!, $customerId: ID!) {
    dissociateHubCustomer(hubId: $hubId, customerId: $customerId)
  }
`;
exports.linkGateway = `
  mutation LinkGateway($gatewayHubId: ID!, $parentHubId: ID!) {
    linkGateway(gatewayHubId: $gatewayHubId, parentHubId: $parentHubId)
  }
`;
exports.unlinkGateway = `
  mutation UnlinkGateway($gatewayHubId: ID!) {
    unlinkGateway(gatewayHubId: $gatewayHubId)
  }
`;
exports.createSensor = `
  mutation CreateSensor($input: CreateSensorInput!) {
    createSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;
exports.createSensorLink = `
  mutation CreateSensorLink($input: CreateSensorLinkInput!) {
    createSensorLink(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;
exports.createSensorGroup = `
  mutation CreateSensorGroup($input: CreateSensorGroupInput!) {
    createSensorGroup(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
    }
  }
`;
exports.updateSensor = `
  mutation UpdateSensor($input: UpdateSensorInput!) {
    updateSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      version
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        breakerAmperage
        voltage
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      equipmentDetails {
        type
        systemAge
        manufacturingDate
        manufacturer
        brand
        model
        serialNumber
        warrantyDuration
        notes
        systemType
        equipmentTonnage
        airFilterConfiguration {
          manufacturer
          modelNumber
          mervRated
          mervRating
          filterSizeHeight
          filterSizeWidth
          filterSizeDepth
          filterMaterial
          systemType
        }
        pressureConfiguration {
          staticPressureTarget
          supplyStaticPressure
          returnStaticPressure
          filterPressureDrop
          triggerAlertOnPressure
        }
        plenumConfiguration {
          shape
          widthInches
          heightInches
          diameterInches
          knownCFM
          airflowCalibrationFactor
        }
        photos {
          url
        }
        isVariableSpeed
        systemVoltage
        compressorRLA
        compressorLRA
      }
      targetStaticPressure
      startingStaticPressure
      replacementDeltaInH2O
      pendingBaselineCapture
      baselineCapturedAt
      baselineCTAmps
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;
exports.updateHubEnergyRate = `
  mutation UpdateHubEnergyRate($input: UpdateHubEnergyRateInput!) {
    updateHubEnergyRate(input: $input) {
      id
      config
    }
  }
`;
// Selects everything onSensorUpdated asks for: it is in that subscription's
// @aws_subscribe list, and AppSync drops the event for every subscriber when
// the mutation selects less (subset rule, see sensorStreamHandler).
exports.updateSensorBranchCircuits = `
  mutation UpdateSensorBranchCircuits($input: UpdateSensorBranchCircuitsInput!) {
    updateSensorBranchCircuits(input: $input) {
      id
      hubId
      serialNumber
      type
      version
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        breakerAmperage
        voltage
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      equipmentDetails {
        type
        systemAge
        manufacturingDate
        manufacturer
        brand
        model
        serialNumber
        warrantyDuration
        notes
        systemType
        equipmentTonnage
        airFilterConfiguration {
          manufacturer
          modelNumber
          mervRated
          mervRating
          filterSizeHeight
          filterSizeWidth
          filterSizeDepth
          filterMaterial
          systemType
        }
        pressureConfiguration {
          staticPressureTarget
          supplyStaticPressure
          returnStaticPressure
          filterPressureDrop
          triggerAlertOnPressure
        }
        plenumConfiguration {
          shape
          widthInches
          heightInches
          diameterInches
          knownCFM
          airflowCalibrationFactor
        }
        photos {
          url
        }
        isVariableSpeed
        systemVoltage
        compressorRLA
        compressorLRA
      }
      targetStaticPressure
      startingStaticPressure
      replacementDeltaInH2O
      pendingBaselineCapture
      baselineCapturedAt
      baselineCTAmps
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;
exports.deleteSensorLink = `
  mutation DeleteSensorLink($input: DeleteSensorLinkInput!) {
    deleteSensorLink(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
    }
  }
`;
// unitState: what the installer says the unit is (ALIVE needs the SW2 reset,
// step 2). Omitted = no reason: the base station removes the node on its own,
// and the cloud treats it as not BROKEN. Returns the row with the removal it
// opened.
exports.deleteSensor = `
  mutation DeleteSensor($id: ID!, $unitState: SensorUnitState) {
    deleteSensor(id: $id, unitState: $unitState) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;
// The installer's "I did the reset" (no unitState) or "Switch to broken"
// (unitState: BROKEN) on a deleted row whose removal is still open.
exports.retrySensorRemoval = `
  mutation RetrySensorRemoval($id: ID!, $unitState: SensorUnitState) {
    retrySensorRemoval(id: $id, unitState: $unitState) {
      id
      hubId
      status
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;
exports.retrySensorInclusion = `
  mutation RetrySensorInclusion($sensorId: ID!) {
    retrySensorInclusion(sensorId: $sensorId)
  }
`;
// Blinks a paired sensor's LEDs. true = command sent, not that it blinked.
exports.identifySensor = `
  mutation IdentifySensor($sensorId: ID!) {
    identifySensor(sensorId: $sensorId)
  }
`;
// Commits a DRAFT row: PENDING plus the sensor/add publish that puts the DSK
// in front of SmartStart. Until this runs the hub has never heard of the unit.
// heldForRemovalOf: the add waits on an old row's unpair and nothing was sent.
exports.beginSensorInclusion = `
  mutation BeginSensorInclusion($sensorId: ID!) {
    beginSensorInclusion(sensorId: $sensorId) {
      id
      hubId
      status
      lastReported
      heldForRemovalOf
    }
  }
`;
// Install sign-off. The installer is taken from the caller's Cognito identity
// server-side, so there is nothing to pass and nothing to spoof.
exports.completeSensorInstall = `
  mutation CompleteSensorInstall($sensorId: ID!) {
    completeSensorInstall(sensorId: $sensorId) {
      id
      hubId
      status
      lastReported
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;
exports.createSensorEvent = `
  mutation CreateSensorEvent($input: CreateSensorEventInput!) {
    createSensorEvent(input: $input) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      metadata
    }
  }
`;
exports.updateSensorAlertStatus = `
  mutation UpdateSensorAlertStatus($input: UpdateSensorAlertStatusInput!) {
    updateSensorAlertStatus(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
    }
  }
`;
exports.updateSensorAlertAcknowledgedState = `
  mutation UpdateSensorAlertAcknowledgedState($input: UpdateSensorAlertAcknowledgedStateInput!) {
    updateSensorAlertAcknowledgedState(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
    }
  }
`;
exports.updateSensorAlertAcknowledgedStateAnonymous = `
  mutation UpdateSensorAlertAcknowledgedStateAnonymous(
    $input: UpdateSensorAlertAcknowledgedStateInput!
  ) {
    updateSensorAlertAcknowledgedStateAnonymous(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
    }
  }
`;
exports.createServiceRequest = `
  mutation CreateServiceRequest($input: CreateServiceRequestInput!) {
    createServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;
exports.updateServiceRequest = `
  mutation UpdateServiceRequest($input: UpdateServiceRequestInput!) {
    updateServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;
exports.createCustomer = `
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;
exports.updateCustomer = `
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;
exports.deleteCustomer = `
  mutation DeleteCustomer($id: ID!) {
    deleteCustomer(id: $id) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;
exports.createServiceCompany = `
  mutation CreateServiceCompany($input: CreateServiceCompanyInput!) {
    createServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;
exports.updateServiceCompany = `
  mutation UpdateServiceCompany($input: UpdateServiceCompanyInput!) {
    updateServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;
// HVAC Filter Alert Mutations
exports.requestFilterService = `
  mutation RequestFilterService($input: FilterServiceRequestInput!) {
    requestFilterService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
exports.clearHvacFilterAlert = `
  mutation ClearHvacFilterAlert($sensorId: ID!, $hubId: ID!) {
    clearHvacFilterAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
exports.orderFilter = `
  mutation OrderFilter($input: FilterOrderRequestInput!) {
    orderFilter(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
// Power Monitor Alert Mutations
exports.requestPowerMonitorService = `
  mutation RequestPowerMonitorService($input: PowerMonitorServiceRequestInput!) {
    requestPowerMonitorService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
exports.clearPowerMonitorAlert = `
  mutation ClearPowerMonitorAlert($sensorId: ID!, $hubId: ID!) {
    clearPowerMonitorAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
exports.requestWaterLeakService = `
  mutation RequestWaterLeakService($input: WaterLeakServiceRequestInput!) {
    requestWaterLeakService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
exports.clearWaterLeakAlert = `
  mutation ClearWaterLeakAlert($sensorId: ID!, $hubId: ID!) {
    clearWaterLeakAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
exports.requestHumidityService = `
  mutation RequestHumidityService($input: HumidityServiceRequestInput!) {
    requestHumidityService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      reason
      status
      priority
      hubId
      sensorId
      alertId
      notes
      accessInstructions
      deviceLocation
      roomType
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;
exports.clearHumidityAlert = `
  mutation ClearHumidityAlert($sensorId: ID!, $hubId: ID!) {
    clearHumidityAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
exports.requestAirQualityService = `
  mutation RequestAirQualityService($input: AirQualityServiceRequestInput!) {
    requestAirQualityService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      reason
      status
      priority
      hubId
      sensorId
      alertId
      notes
      accessInstructions
      deviceLocation
      roomType
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;
exports.updateMyNotificationPreferences = `
  mutation UpdateMyNotificationPreferences($input: UpdateUserNotificationPreferencesInput!) {
    updateMyNotificationPreferences(input: $input) {
      userId
      sms {
        enabled
        notifyOnResolve
        water
        power
        hvac
        airQuality
        connectivity
      }
      email {
        enabled
        notifyOnResolve
        water
        power
        hvac
        airQuality
        connectivity
      }
      push {
        enabled
        notifyOnResolve
        water
        power
        hvac
        airQuality
        connectivity
      }
      updatedAt
    }
  }
`;
